import { ResourceNode, SchedulerEvent } from '../../types';

export const normalizeProject = (apiProject: any): ResourceNode => {
  return {
    id: String(apiProject.AccountProjectId),
    name: apiProject.ProjectName,
    subtitle: apiProject.ClientName,
    type: 'project',
    hasChildren: true,
    children: [],
    expanded: false,
    depth: 0,
    TotalAllocatedHours: apiProject?.TotalAllocationHours,
    originalData: apiProject,
    IsProjectManager: apiProject?.IsProjectManager,
    IsMyProject: apiProject?.IsMyProject
  };
};

// Convert Employee API Response to ResourceNode
export const normalizeEmployee = (apiEmployee: any, parentId: any): ResourceNode => {
  const permissionFlag = apiEmployee?.ApplyAllProjectsForAdd ? apiEmployee?.ApplyAllProjectsForAdd : apiEmployee?.ApplyMyProjectsForAdd;
  return {
    id: String(apiEmployee.AccountEmployeeId),
    name: apiEmployee.EmployeeName,
    type: 'person',
    hasChildren: false,
    children: [],
    depth: 1,
    parentId: parentId?.id,
    ProjectId: parentId?.id,
    originalData: apiEmployee,
    parentName: parentId?.name,
    HoursPerDay: apiEmployee?.HoursPerDay,
    TotalAllocatedHours: apiEmployee?.TotalAllocationHours,
    AccountEmployeeId: apiEmployee?.AccountEmployeeId,
    permissionForAdd: permissionFlag
  };
};

export const normalizeEvent = (apiEvent: any, resourceId: string, type: string, HoursPerDay?: any): SchedulerEvent => {

  let color = '#ede9fe';
  if (type === 'project') color = '#ede9fe';
  if (type === 'milestone') color = '#FED18E';
  if (type === 'timeOff') color = '#9fe7dcff';

  const eventId = type === 'timeOff'
    ? `timeoff-${resourceId}-${apiEvent.StartDate}-${apiEvent.TimeOffTypeId || Math.random()}`
    : apiEvent.AccountEmployeeSchedulerId
      ? `task-${apiEvent.AccountEmployeeSchedulerId}`
      : `evt-${resourceId}-${Math.random()}`;
  return {
    id: eventId,
    AccountProjectMilestoneId: apiEvent?.AccountProjectMilestoneId,
    ProjectId: apiEvent?.AccountProjectId,
    resourceId: resourceId,
    title: apiEvent.AccountProjectTask || apiEvent.TaskName || apiEvent.MilestoneDescription,
    start: new Date(apiEvent.StartDate || apiEvent.MilestoneDate),
    end: new Date(apiEvent.EndDate || apiEvent.MilestoneDate || apiEvent.StartDate),
    allocatedHours: apiEvent?.AllocationHours || null,
    allocationHoursPerDay: apiEvent?.AllocationHoursPerDay || null,
    HoursPerDay: HoursPerDay,
    AccountEmployeeSchedulerId: apiEvent.AccountEmployeeSchedulerId || null,
    AccountProjectTaskId: apiEvent.AccountProjectTaskId,
    TimeOffTypeId: apiEvent?.TimeOffTypeId,
    TimeOffTypeName: apiEvent?.TimeOffTypeName,
    color: color,
    types: type === 'milestone' ? 'milestone' : (type === 'project' ? 'project' : (type === 'timeOff' ? 'timeOff' : 'task'))
  };
};

export const countWorkingDays = (start: Date, end: Date) => {
  let count = 0;
  let current = new Date(start);

  while (current <= end) {
    const day = current.getDay();
    if (day !== 0 && day !== 6) {
      count++;
    }
    current.setDate(current.getDate() + 1);
  }

  return count;
}

///Dummy Data Normalization///
export const normalizeEventDummy = (apiEvent: any, resourceId: string, type: string): SchedulerEvent => {

  let color = '#D7C6B4';
  if (type === 'projectEmployee') color = '#E8F3DB';
  if (type === 'milestone') color = '#FED18E';

  return {
    id: apiEvent.AccountEmployeeSchedulerId
      ? `task-${apiEvent.AccountEmployeeSchedulerId}`
      : `evt-${resourceId}-${Math.random()}`,
    AccountProjectMilestoneId: apiEvent?.AccountProjectMilestoneId,
    ProjectId: apiEvent?.AccountProjectId,
    resourceId: resourceId,
    title: apiEvent.AccountProjectTask || apiEvent.TaskName || apiEvent.MilestoneDescription,
    start: new Date(apiEvent.StartDate || apiEvent.MilestoneDate),
    end: new Date(apiEvent.EndDate || apiEvent.MilestoneDate || apiEvent.StartDate),
    allocatedHours: apiEvent?.AllocationHours || null,
    allocationHoursPerDay: apiEvent?.AllocationHoursPerDay || null,
    AccountEmployeeSchedulerId: apiEvent.AccountEmployeeSchedulerId || null,
    AccountProjectTaskId: apiEvent.AccountProjectTaskId,
    color: color,
    types: type === 'milestone' ? 'milestone' : (type === 'projectEmployee' ? 'projectEmployee' : 'task')
  };
};

export const normalizeTeamEmployees = (apiEmployee: any): ResourceNode => {
  return {
    id: String(apiEmployee.AccountEmployeeId),
    name: apiEmployee.EmployeeName,
    subtitle: apiEmployee.ClientName,
    type: 'team',
    hasChildren: true,
    children: [],
    expanded: false,
    depth: 0,
    TotalAllocatedHours: apiEmployee?.TotalAllocationHours,
    originalData: apiEmployee
  };
};
export const normalizeProjectEvent = (apiEvent: any, resourceId: string, type: string, HoursPerDay?: any, parentResourceId?: string): SchedulerEvent => {
  let color = '#ede9fe';
  if (type === 'project') color = '#ede9fe';
  if (type === 'milestone') color = '#FED18E';
  if (type === 'timeoff') color = '#FAD1DF';
  if (type === 'timeOff') color = '#FAD1DF';

  const eventId = type === 'timeoff' || type === 'timeOff'
    ? `timeoff-${parentResourceId || resourceId}-${apiEvent.StartDate}-${apiEvent.TimeOffTypeId || Math.random()}`
    : apiEvent.AccountEmployeeSchedulerId
      ? `task-${apiEvent.AccountEmployeeSchedulerId}`
      : `evt-${resourceId}-${Math.random()}`;
  
  return {
    id: eventId,
    AccountProjectMilestoneId: apiEvent?.AccountProjectMilestoneId,
    ProjectId: apiEvent?.AccountProjectId,
    AccountEmployeeId: apiEvent?.AccountEmployeeId,
    resourceId: resourceId,
    title: apiEvent.AccountProjectTask || apiEvent.TaskName || apiEvent.MilestoneDescription || 
           apiEvent.TimeOffTypeName || 'Time Off',
    start: new Date(apiEvent.StartDate || apiEvent.MilestoneDate),
    end: new Date(apiEvent.EndDate || apiEvent.MilestoneDate || apiEvent.StartDate),
    allocatedHours: apiEvent?.AllocationHours || null,
    allocationHoursPerDay: apiEvent?.AllocationHoursPerDay || null,
    HoursPerDay: HoursPerDay,
    AccountEmployeeSchedulerId: apiEvent.AccountEmployeeSchedulerId || null,
    AccountProjectTaskId: apiEvent.AccountProjectTaskId,
    TimeOffTypeId: apiEvent?.TimeOffTypeId,
    TimeOffTypeName: apiEvent?.TimeOffTypeName,
    parentResourceId: parentResourceId, 
    color: color,
    types: type === 'milestone' ? 'milestone' : 
           (type === 'project' ? 'project' : 
           (type === 'timeoff' ? 'timeOff' : 
           (type === 'timeOff' ? 'timeOff' : 
           (type === 'taskTeam' ? 'taskTeam' : 'task'))))
  };
};
